import { FieldExtraFormatter } from './validations/validations';

export const removeAccents = (v?: string) =>
  v
    ?.normalize('NFD')
    ?.replace(/([\u0300-\u036f])/g, '')
    ?.replace(/[^a-zA-Z0-9ñÑ\s]/g, '') || '';

export const EXTRA_FORMATTERS: Record<
  FieldExtraFormatter,
  (v: string) => string
> = {
  uppercase: (v: string) => v?.toUpperCase() || '',
  noAccents: (v: string) => removeAccents(v) || '',
  uppercaseWithoutAccents: (v: string) => removeAccents(v)?.toUpperCase() || '',
};
